import { Signal } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { skip, Subscription } from 'rxjs';

/**
 * Runs `onChange` on every change of `source`, skipping the initial value (like `valueChanges`).
 * Unlike `effect()`, the callback may freely write signals. Requires an injection context.
 */
export function onSignalChange<T>(source: Signal<T>, onChange: (value: T) => void): Subscription {
  return toObservable(source).pipe(skip(1), takeUntilDestroyed()).subscribe(onChange);
}
